$(document).ready(function () {
    const burger = $('.js-burger-toggle');
    const nav = $('.js-nav');

    burger.click(function(){
        $(this).toggleClass('open');
        nav.toggle(300);
    });
});
